/* Copyright (c) 2022 by Nobuaki Honma (https://codepen.io/nobuakihonma/pen/dYbqLQ)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */

.miniLoader {
  --loader-color: var(--ink-90);
  --load-ping-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  display: block;
  position: fixed;
  top: 0;
  left: 320px; /* match .aside width in Router.module.scss (sidebar) */
  margin: 2em;
  height: 24px;
  width: 24px;
  text-indent: -9999em;
  transition: 0.5s opacity;

  &[hidden] {
    opacity: 0;
  }

  &[stopped] {
    display: none;
  }

  span {
    display: block;
    height: 24px;
    width: 24px;

    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      height: 24px;
      width: 24px;
      border: 2px solid var(--loader-color);
      border-radius: 50%;
      opacity: 0;
      animation: 1.5s cubic-bezier(0.075, 0.82, 0.165, 1) infinite miniLoader-1;
    }

    &::after {
      animation: 1.5s cubic-bezier(0.075, 0.82, 0.165, 1) 0.25s infinite
        miniLoader-2;
    }
  }
}

@keyframes miniLoader-1 {
  0% {
    scale: 0;
    opacity: 1;
  }
  to {
    scale: 1.5;
    opacity: 0;
  }
}

@keyframes miniLoader-2 {
  0% {
    scale: 0;
    opacity: 1;
  }
  to {
    scale: 1;
    opacity: 0;
  }
}
